import BulletPoints from './BulletPoints'

export default BulletPoints
